module.exports = __webpack_public_path__ + "static/z_tall_soyou'recominghome-33f45febe4b82f5e76150f16438c6f11.jpg";